import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ searchQuery }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-12 text-center">
      <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name={searchQuery ? "Search" : "Package"} size={40} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        {searchQuery ? 'No items found' : 'No inventory items'}
      </h3>
      <p className="text-sm text-muted-foreground max-w-md mx-auto">
        {searchQuery 
          ? `We couldn't find any items matching "${searchQuery}". Try adjusting your search or filters.`
          : 'Your inventory is currently empty. Items will appear here once they arrive at our warehouse.'}
      </p>
    </div>
  );
};

export default EmptyState;